module.exports = __webpack_public_path__ + "img/mozgo_logo_text.10d62edc.svg";